<template>
  <div class="flex flex-col w-[266px]">
    <div class="flex flex-col py-3 px-2" :class="{ border_bottom: true }">
      <span
        class="secondary_color font-semibold text-[11px] leading-[17px] p-3 pt-1"
      >
        ALL VIEWS
      </span>
      <a-input
        v-model:value="searchQuery"
        class="input_medium"
        placeholder="Search here"
        allow-clear
        auto-focus
      />
    </div>

    <div
      class="flex flex-col p-2 gap-1 max-h-[200px] overflow-y-auto"
      :class="{ border_bottom: true }"
    >
      <div
        v-for="(view, index) in filteredViews"
        :key="`inactive_view_${view.id}_${index}`"
        class="dropdown_item flex items-center flex-row gap-2 px-3 py-2 rounded-lg cursor-pointer flex-shrink-0"
        @click="$emit('activate-view', view.id)"
      >
        <span class="text-sm flex items-center gap-1">
          {{ view.name }}
          <ThemeImage
            v-if="view.sharing_scope === 'personal'"
            class="size-3.5"
            :icon="imageNames.LOCK_GREY"
            alt="private"
          />
        </span>
      </div>

      <div
        v-if="filteredViews.length === 0"
        class="flex flex-col items-center justify-center py-6 px-4"
      >
        <ThemeImage
          :icon="imageNames.EMPTY_SCREEN_GREY"
          alt="empty_icon"
          class="size-16"
        />
        <span class="text-sm secondary_color text-center mt-2">
          No views found!
        </span>
      </div>
    </div>

    <div class="flex flex-col p-2">
      <div
        class="dropdown_item flex items-center flex-row gap-2 px-5 py-3 rounded-lg cursor-pointer"
        @click="$emit('add-new-view')"
      >
        <span class="text-sm flex items-center gap-2"
          ><ThemeImage :icon="imageNames.PLUS" class="size-4" /> Add New
          View</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  inactiveViews: { type: Array, default: () => [] },
});

const emit = defineEmits(["activate-view", "add-new-view"]);

const searchQuery = ref("");

const filteredViews = computed(() => {
  if (!searchQuery.value.trim()) {
    return props.inactiveViews;
  }

  const query = searchQuery.value.toLowerCase().trim();
  return props.inactiveViews.filter((view) =>
    view.name?.toLowerCase().includes(query),
  );
});
</script>

<style scoped></style>
